import { API_BASE_URL, endpoints } from "./config";
import { authHeadersForGet, authHeadersJson } from "./http";
import { Brand, CreateBrandDto } from "../types/brand";

export const brandsApi = {
  getAll: async (): Promise<Brand[]> => {
    const response = await fetch(`${API_BASE_URL}${endpoints.brands.getAll}`, {
      headers: authHeadersForGet(),
    });
    return response.json();
  },

  search: async (term?: string): Promise<Brand[]> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.brands.search(term)}`,
      { headers: authHeadersForGet() }
    );
    return response.json();
  },

  getOne: async (reference: string): Promise<Brand> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.brands.getOne(reference)}`,
      { headers: authHeadersForGet() }
    );
    return response.json();
  },

  create: async (brand: CreateBrandDto): Promise<Brand> => {
    const response = await fetch(`${API_BASE_URL}${endpoints.brands.create}`, {
      method: "POST",
      headers: authHeadersJson(),
      body: JSON.stringify(brand),
    });
    return response.json();
  },

  createBulk: async (
    brands: CreateBrandDto[]
  ): Promise<{ success: Brand[]; errors: any[] }> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.brands.createBulk}`,
      {
        method: "POST",
        headers: authHeadersJson(),
        body: JSON.stringify(brands),
      }
    );
    return response.json();
  },

  update: async (reference: string, brand: CreateBrandDto): Promise<Brand> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.brands.update(reference)}`,
      {
        method: "PUT",
        headers: authHeadersJson(),
        body: JSON.stringify(brand),
      }
    );
    return response.json();
  },

  delete: async (reference: string): Promise<boolean> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.brands.delete(reference)}`,
      {
        method: "DELETE",
        headers: authHeadersForGet(),
      }
    );
    return response.ok;
  },
};
